export const InvestorDashboardBorrowerStatuses = [
	{ id: 'InComplete', name: 'Incomplete' },
	{ id: 'Pending', name: 'Pending' },
	{ id: 'Approved', name: 'Approved' },
	{ id: 'Archived', name: 'Archived' },
];

export const InvestorDashboardLoanStatuses = [
	{ id: 'Pending', name: 'Pending' },
	{ id: 'DueDiligence', name: 'Due Diligence' },
	{ id: 'Approved', name: 'Approved' },
	{ id: 'FullyFilled', name: 'Fully Filled' },
	{ id: 'OnTime', name: 'On Time' },
	{ id: 'Late', name: 'Late' },
	{ id: 'Completed', name: 'Fully Repaid' },
	{ id: 'Default', name: 'Defaulted' },
	{ id: 'Rejected', name: 'Rejected' },
];
